import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../../services/translation/translation.service';

@Pipe({
  name: 'translate'
})
export class TranslationPipe implements PipeTransform {

  constructor(public translationService: TranslationService) {
  }

  transform(value: any, args: string[]): any {
    if (args && args.length > 0) {
      return this.translationService.translateArgs(value, ...args);
    } else {
      return this.translationService.translate(value);
    }
  }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/pipes/translation/translation.pipe.ts